import {
  SET_USER_METRICS,
  SET_USER_LIST,
  SET_SINGLE_USER,
} from 'modules/Users/actions'

const initialState = {
  userMetrics: {},
  userList: {},
  singleUserData: {},
}

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_USER_METRICS:
      return {
        ...state,
        userMetrics: action.data,
      }
    case SET_USER_LIST:
      return {
        ...state,
        userList: action.data,
      }
    case SET_SINGLE_USER:
      return {
        ...state,
        singleUserData: action.data,
      }
    default:
      return state
  }
}
